import PrductGallery from "./PrductGallery";

export default PrductGallery;